import React from 'react';
import { Col } from 'antd';
import { Colors } from '@common/tokens';
import { InfoTooltip } from '@common/components';

type Props = {
  label: string;
  info: string | React.ReactNode;
  tooltip?: string;
  firstColumnOffset?: number;
};

export const SuppliersManagementViewDrawerInfoRow = ({
  label,
  info,
  tooltip,
  firstColumnOffset = 4,
}: Props) => (
  <>
    <Col span={firstColumnOffset}>
      <div className="supplier-view-drawer__info">
        <label className="supplier-view-drawer__info-label">{label}</label>
      </div>
    </Col>
    <Col span={24 - firstColumnOffset}>
      <div className="supplier-view-drawer__info">
        {info}
        {!!tooltip && <InfoTooltip title={tooltip} size="sm" leftOffset={12} />}
      </div>
    </Col>
    <style jsx>{`
      .supplier-view-drawer__info {
        font-size: 16px;
      }

      .supplier-view-drawer__info-label {
        color: ${Colors.midnightLighter};
      }
    `}</style>
  </>
);
